import React from 'react';

export const DiscountIcon: React.FC = () => (
	<svg width='1.6rem' height='2rem' viewBox='0 0 16 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect x='10' y='12' width='5' height='7' rx='2.5' stroke='currentColor' strokeWidth='1.5' />
		<rect x='1' y='1' width='5' height='7' rx='2.5' stroke='currentColor' strokeWidth='1.5' />
		<path d='M14 1L2 19' stroke='currentColor' strokeWidth='1.5' />
	</svg>
);
